import { Row } from "@/components";
import { CandidacyQuickActions } from "@jobs/pipeline/shared/CandidacyQuickActions";
import { Button } from "@/components/ui/button";
import { TableCell } from "@/components/ui/table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import {
  MinimalCandidacy,
  PipelineStage,
  PipelineViewPreference,
} from "@/types";

export const NextStepCell = ({
  candidacy,
  isShortlistBlocked,
  stage,
  onShortlist,
  onReject,
  onOpenMessages,
}: {
  candidacy: MinimalCandidacy;
  isShortlistBlocked: boolean;
  stage: PipelineStage;
  onShortlist: (candidacy: MinimalCandidacy) => void;
  onReject: (candidacy: MinimalCandidacy) => void;
  onOpenMessages: (candidacy: MinimalCandidacy) => void;
}) => {
  /* Render */
  const render = () => {
    if (stage === PipelineStage.APPLIED) {
      return (
        <AppliedActions
          candidacy={candidacy}
          isShortlistBlocked={isShortlistBlocked}
          onReject={onReject}
          onShortlist={onShortlist}
        />
      );
    }

    return (
      <CandidacyQuickActions
        candidacy={candidacy}
        className="justify-end"
        onOpenMessages={onOpenMessages}
        pipelineView={PipelineViewPreference.TABLE}
      />
    );
  };

  return (
    <TableCell
      className="py-3"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {render()}
    </TableCell>
  );
};

const AppliedActions = ({
  candidacy,
  isShortlistBlocked,
  onReject,
  onShortlist,
}: {
  candidacy: MinimalCandidacy;
  isShortlistBlocked: boolean;
  onReject: (candidacy: MinimalCandidacy) => void;
  onShortlist: (candidacy: MinimalCandidacy) => void;
}) => (
  <Row className="items-center justify-end gap-1.5">
    {isShortlistBlocked ? (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button
                className="h-8 px-3 text-xs"
                disabled
                size="sm"
                variant="secondary"
              >
                Shortlist
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent className="text-xs" side="top">
            Set up your calendar to enable shortlisting
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ) : (
      <Button
        className="h-8 px-3 text-xs"
        onClick={() => {
          onShortlist(candidacy);
        }}
        size="sm"
        variant="secondary"
      >
        Shortlist
      </Button>
    )}
    <Button
      className="h-8 px-3 text-xs text-slate-600 hover:text-slate-900"
      onClick={() => {
        onReject(candidacy);
      }}
      size="sm"
      variant="ghost"
    >
      Reject
    </Button>
  </Row>
);
